"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShowMore = void 0;
const react_1 = require("react");
const react_use_1 = require("react-use");
const useShowMore = ({ blockMaxHeight = 400, defaultClosed = true, disabled = false } = {}, deps = []) => {
    const [ruleBlockRef, { height: ruleBlockHeight }] = (0, react_use_1.useMeasure)();
    const showMoreButtonRef = (0, react_1.useRef)();
    const [lastClosedY, setLastClosedY] = (0, react_1.useState)(0);
    const [lastOpenY, setLastOpenY] = (0, react_1.useState)(0);
    const [ruleBlockOpen, setRuleBlockOpen] = (0, react_1.useState)(false);
    const hasShowMoreButton = ruleBlockHeight > blockMaxHeight;
    const [codeLoaded, setCodeLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!disabled) {
            if (!codeLoaded) {
                setCodeLoaded(true);
            }
            if (hasShowMoreButton) {
                if (!ruleBlockOpen) {
                    setLastClosedY(showMoreButtonRef.current.offsetTop);
                }
                else {
                    setLastOpenY(showMoreButtonRef.current.offsetTop);
                }
            }
        }
    }, [disabled, hasShowMoreButton, ruleBlockOpen, ...deps]);
    return {
        onClickButton: () => {
            if (ruleBlockOpen) {
                window.scrollBy(0, lastClosedY - lastOpenY);
            }
            setRuleBlockOpen(!ruleBlockOpen);
        },
        blockRef: ruleBlockRef,
        buttonRef: showMoreButtonRef,
        closed: !disabled && ((!codeLoaded && defaultClosed) || (hasShowMoreButton && !ruleBlockOpen)),
        applicable: !disabled && hasShowMoreButton,
    };
};
exports.useShowMore = useShowMore;
